import { Link } from "react-router-dom";
import { hotTags } from "@/mocks/site";

export default function Ticker() {
  const items = [...hotTags, ...hotTags];
  return (
    <div className="flex items-stretch bg-background-100 border-b border-background-200 overflow-hidden">
      <div className="shrink-0 flex items-center gap-2 bg-primary-500 text-background-50 px-4 md:px-5 py-2.5 text-xs md:text-sm font-medium">
        <i className="ri-fire-line text-base" aria-hidden="true" />
        <span className="whitespace-nowrap">今日热点</span>
      </div>
      <div className="relative flex-1 overflow-hidden flex items-center">
        <div className="marquee-track animate-ticker">
          {items.map((tag, index) => (
            <Link
              key={`${tag}-${index}`}
              to={`/gossip?q=${encodeURIComponent(tag)}`}
              className="mx-4 text-xs md:text-sm text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              #{tag}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}